import { Checkbox } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import { withRouter } from 'react-router-dom'
import Typography from '../../../fhg/components/Typography'
import { ImageList } from '@material-ui/core'
import { ImageListItem, ImageListItemBar } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import React, { useState, useEffect, useRef, useCallback } from 'react'
import {
    THUMBNAIL_SIZE,
    PLACEHOLDER_IMAGE,
    IMAGE_VIEW_KEYS,
    IMAGE_VIEW_CONVERT,
} from '../../../Constants'
import { CheckboxBackground, CheckboxSelected } from '../../../Icons'
import PhotoMoreMenu from '../components/PhotoMoreMenu'
import { Modal } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import DeleteIcon from '@material-ui/icons/Delete'
import { Auth } from 'aws-amplify'
import {
    buildRequestHeaders,
    isAdmin,
    isMultipleOrganization,
} from '../../../Utils/ServerUtil'
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline'
import { Button, Tooltip } from '@material-ui/core'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import { Box, LinearProgress, CircularProgress, Alert, Snackbar } from '@mui/material'
import { getCurrentOrganizationUrlParam } from '../../../Utils/helpers'
import { getUserData } from '../../../Utils/ServerUtil'
import { extractImageUrlFromVariants } from '../../../fhg/utils/Utils'
import ResolutionIndicator from '../components/ResolutionIndicator'
import config from '../../../config/runtime'
import { apiService, useItemById } from '../../../services/api'
import { logger } from '../../../config/logger'

const checkboxStyles = (theme) => ({
    root: {
        color: `${theme.palette.environment.light.divider} !important`,
        '&$checked': {
            color: `${theme.palette.brand.blue} !important`, //#489AC7
        },
    },
    checked: {},
})

function CustomCheckbox4(props) {
    return (
        <Checkbox
            color="default"
            checkedIcon={<CheckboxSelected />}
            icon={
                <CheckboxBackground
                    stroke={props.theme.palette.environment.light.divider}
                />
            }
            {...props}
        />
    )
}

export const CustomCheckboxSolid = withStyles(checkboxStyles, {
    withTheme: true,
})(CustomCheckbox4)

const styles = (theme) => ({
    verticalThumbs: {
        height: '100%',
        width: THUMBNAIL_SIZE + 8,
        display: 'block',
        padding: '0 4px',
        marginLeft: '4px !important',
        marginTop: '0px !important',
        borderLeft: `1px solid ${theme.palette.divider}`,
    },
    downloadButton: {
        position: 'absolute',
        top: -50,
        right: 8,
        zIndex: 1010,
        color: theme.palette.common.white,
        backgroundColor: '#4f2682',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
        },
    },
    videoDeleteButton: {
        position: 'absolute',
        top: 2,
        right: 2,
        zIndex: 1005,
        padding: 4,
        color: theme.palette.common.white,
        backgroundColor: 'rgba(0, 0, 0, 0.45)',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.65)',
        },
    },
    horizontalThumbs: {
        height: THUMBNAIL_SIZE,
        width: '100%',
        flexWrap: 'nowrap',
        flex: '0 0 auto',
        paddingTop: 4,
        marginLeft: '0px !important',
        marginTop: '4px !important',
        marginBottom: '7px !important',
        borderTop: `1px solid ${theme.palette.divider}`,
        overflowY: 'hidden',
    },
    titleBar: {
        background:
            'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
    },
    moreTitleBar: {
        background: 'transparent',
        width: '100%',
    },
    titleText: {
        fontSize: `${theme.size.font['item-title']}rem`,
        lineHeight: `${theme.size.lineheight['item-title']}rem`,
        letterSpacing: `${theme.size.letterspacing['item-title']}rem`,
    },
    actionIconStyle: {
        width: '100%',
    },
    titleWrap: {
        display: 'none',
    },
    imageType: {
        background:
            'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
        bottom: 0,
        position: 'absolute',
        color: 'white',
        textAlign: 'center',
        width: '100%',
        paddingBottom: 4,
        marginLeft: 4,
    },
})

const ThumbnailList = (props) => {
    const {
        classes,
        thumbColumns,
        images,
        selectedImage,
        onDeletePhoto,
        onRefresh,
        onSelect,
        onSelectThumbnail,
        onMovePhoto,
        selected,
        onSortAllPhotos,
        evalItem,
    } = props

    const [currentVideos, setCurrentVideos] = useState(
        evalItem?.video_data || evalItem?.attachment_data || []
    )
    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false)
    const [selectedVideo, setSelectedVideo] = useState(null)
    const [thumnailImages, setThumnailImages] = useState([])
    const [selectedThumbnailIndex, setSelectedThumbnailIndex] = useState(0)
    const [isDownloading, setIsDownloading] = useState(false)
    const [downloadProgress, setDownloadProgress] = useState(0)
    const [totalImages, setTotalImages] = useState(0)

    const [videoToDelete, setVideoToDelete] = useState(null)
    const [isDeletingVideo, setIsDeletingVideo] = useState(false)
    const [videoDeleteSuccessOpen, setVideoDeleteSuccessOpen] = useState(false)
    const [videoDeleteError, setVideoDeleteError] = useState('')

    const thumbnailRefs = useRef([])

    // Use React Query hook to fetch item data
    const {
        data: itemData,
        isLoading,
        error,
        refetch: refetchItem,
    } = useItemById(evalItem?.item_id, {
        enabled: !!evalItem?.item_id,
    })

    // Update thumbnail images/videos when item data is fetched
    useEffect(() => {
        if (itemData?.image_data) {
            console.log('Check Image Data ========>', itemData?.image_data)
            setThumnailImages(itemData.image_data)
        }

        if (itemData?.video_data || itemData?.attachment_data) {
            setCurrentVideos(itemData?.video_data || itemData?.attachment_data || [])
        }
    }, [itemData])

    const scrollThumbnailIntoView = useCallback((index) => {
        // Use the ref to scroll the selected thumbnail into view
        if (thumbnailRefs.current[index]) {
            thumbnailRefs.current[index].scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            })
        }
    }, [])

    // Component lifecycle effects
    useEffect(() => {
        imageShuffle()

        const handleKeyDown = (event) => {
            if (event.key === 'ArrowRight') {
                // Move to the next thumbnail
                setSelectedThumbnailIndex((prevIndex) => {
                    const totalItems =
                        thumnailImages.length + currentVideos.length
                    const nextIndex = (prevIndex + 1) % totalItems
                    scrollThumbnailIntoView(nextIndex) // Scroll into view
                    return nextIndex
                })
            } else if (event.key === 'ArrowLeft') {
                // Move to the previous thumbnail
                setSelectedThumbnailIndex((prevIndex) => {
                    const totalItems =
                        thumnailImages.length + currentVideos.length
                    const nextIndex = (prevIndex - 1 + totalItems) % totalItems
                    scrollThumbnailIntoView(nextIndex) // Scroll into view
                    return nextIndex
                })
            }
        }

        // Add event listener for keyboard navigation
        document.addEventListener('keydown', handleKeyDown)

        return () => {
            // Remove event listener when the component is unmounted
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, []) // Empty dependency array - only run once on mount

    // The old latestImageData method has been replaced by the useItemById React Query hook

    const imageShuffle = useCallback(() => {
        // Use functional update to avoid dependency on thumnailImages
        setThumnailImages((currentImages) => {
            // Clone the currentImages array
            const clonedImages = [...currentImages]

            // Custom sorting function to place "AMKT" first
            const customSort = (a, b) => {
                if (a.image_view === 'AMKT') {
                    return -1 // "AMKT" comes first
                }
                if (b.image_view === 'AMKT') {
                    return 1 // "AMKT" comes first
                }
                return 0 // Keep the original order for other items
            }

            // Sort the clonedImages array using the customSort function
            clonedImages.sort(customSort)
            return clonedImages
        })
    }, [])

    const handleSelect = useCallback(
        (index) => (event) => {
            event.stopPropagation()
            event.preventDefault()

            const selectedArray = selected.slice(0)
            selectedArray[index] = event.target.checked
            onSelectThumbnail && onSelectThumbnail(selectedArray)
        },
        [selected, onSelectThumbnail]
    )

    const handleVideoThumbnailClick = useCallback((video) => {
        setIsVideoModalOpen(true)
        setSelectedVideo(video)
    }, [])

    const handleVideoModalClose = useCallback(() => {
        setIsVideoModalOpen(false)
        setSelectedVideo(null)
    }, [])

    const requestDeleteVideo = useCallback((video) => {
        setVideoToDelete(video)
    }, [])

    const handleCancelDeleteVideo = useCallback(() => {
        if (isDeletingVideo) return
        setVideoToDelete(null)
    }, [isDeletingVideo])

    const handleConfirmDeleteVideo = useCallback(async () => {
        const video = videoToDelete
        const itemId = video?.item_id || evalItem?.item_id
        const videoId = video?.video_id

        if (!itemId || !videoId) {
            setVideoToDelete(null)
            return
        }

        setIsDeletingVideo(true)

        try {
            logger.info('video_delete_start', {
                item_id: itemId,
                video_id: videoId,
            })

            await apiService.delete(
                `/items/${itemId}/videos/${videoId}`,
                {},
                'v1'
            )

            let nextVideos
            setCurrentVideos((prev) => {
                nextVideos = Array.isArray(prev)
                    ? prev.filter((v) => v?.video_id !== videoId)
                    : []
                return nextVideos
            })

            logger.info('video_delete_success', {
                item_id: itemId,
                video_id: videoId,
                remaining_video_count: nextVideos?.length || 0,
            })

            try {
                const expectedVideoCount = nextVideos?.length || 0
                await apiService.request(
                    `/items/${itemId}`,
                    {
                        method: 'PATCH',
                        body: {
                            expected_video_count: expectedVideoCount,
                        },
                    },
                    'v1'
                )
                logger.info('expected_video_count_patch_success', {
                    item_id: itemId,
                    expected_video_count: expectedVideoCount,
                })
            } catch (error) {
                logger.error('expected_video_count_patch_failure', {
                    item_id: itemId,
                    expected_video_count: nextVideos?.length || 0,
                    error_class: error && error.name,
                    message_code: error && error.message,
                })
            }

            if (selectedVideo?.video_id === videoId) {
                setIsVideoModalOpen(false)
                setSelectedVideo(null)
            }

            setVideoToDelete(null)
            setVideoDeleteSuccessOpen(true)

            onRefresh && onRefresh()
            refetchItem && (await refetchItem())
        } catch (error) {
            logger.error('video_delete_failure', {
                item_id: itemId,
                video_id: videoId,
                error_class: error && error.name,
                message_code: error && error.message,
            })
            setVideoDeleteError('Failed to delete video. Please try again.')
        } finally {
            setIsDeletingVideo(false)
        }
    }, [videoToDelete, evalItem?.item_id, selectedVideo?.video_id, onRefresh, refetchItem])

    const downloadAllImages = useCallback(async () => {
        if (!thumnailImages || thumnailImages.length === 0) {
            alert('No images available to download')
            return
        }

        // Set downloading state and initialize progress
        setIsDownloading(true)
        setDownloadProgress(0)
        setTotalImages(thumnailImages.length)

        const zip = new JSZip()
        const imgFolder = zip.folder('images')

        // Helper for fetching with retry and cache busting
        const fetchImage = async (url, retries = 3) => {
            try {
                // Add cache buster to avoid CORS issues with cached opaque responses
                const urlObj = new URL(url)
                urlObj.searchParams.append('cb', Date.now())

                const response = await fetch(urlObj.toString(), {
                    mode: 'cors',
                    cache: 'no-store',
                })

                if (!response.ok) throw new Error(`HTTP ${response.status}`)
                return await response.blob()
            } catch (err) {
                if (retries > 0) {
                    await new Promise((r) => setTimeout(r, 1000))
                    return fetchImage(url, retries - 1)
                }
                throw err
            }
        }

        // Concurrency limit
        const CONCURRENT_LIMIT = 5
        const queue = [
            ...thumnailImages.map((img, i) => ({ ...img, originalIndex: i })),
        ]
        const results = []

        const worker = async () => {
            while (queue.length > 0) {
                const image = queue.shift()
                try {
                    const imageUrl =
                        extractImageUrlFromVariants(image, 'original') || ''

                    if (!imageUrl) throw new Error('No image URL')

                    // Get the original filename or create a default one
                    let fileName =
                        image.original_filename ||
                        `image_${image.originalIndex}`

                    // Ensure proper file extension based on MIME type or URL
                    if (!fileName.match(/\.(jpg|jpeg|png|gif|webp|bmp)$/i)) {
                        const urlExtension = imageUrl
                            .split('?')[0]
                            .split('.')
                            .pop()
                            .toLowerCase()
                        const isValidExt = [
                            'jpg',
                            'jpeg',
                            'png',
                            'gif',
                            'webp',
                            'bmp',
                        ].includes(urlExtension)
                        fileName += `.${isValidExt ? urlExtension : 'jpg'}`
                    }

                    const blob = await fetchImage(imageUrl)

                    // Check if blob has a valid image MIME type
                    const validImageTypes = [
                        'image/jpeg',
                        'image/png',
                        'image/gif',
                        'image/webp',
                        'image/bmp',
                    ]
                    const contentType = blob.type || 'image/jpeg'

                    if (!validImageTypes.includes(contentType)) {
                        console.warn(
                            `File ${fileName} has non-image MIME type: ${contentType}`
                        )
                    }

                    // Add the file to the zip
                    imgFolder.file(fileName, blob, { binary: true })

                    results.push({ success: true, fileName })
                } catch (error) {
                    console.error(
                        `Error downloading ${image.original_filename || 'image'}:`,
                        error
                    )
                    results.push({
                        success: false,
                        fileName: image.original_filename || 'image',
                    })
                } finally {
                    setDownloadProgress((prev) => prev + 1)
                }
            }
        }

        // Start workers
        const workers = Array(Math.min(CONCURRENT_LIMIT, thumnailImages.length))
            .fill(null)
            .map(() => worker())

        await Promise.all(workers)

        try {
            const failedImages = results
                .filter((r) => !r.success)
                .map((r) => r.fileName)

            if (failedImages.length > 0) {
                console.warn('Failed to download some images:', failedImages)
                alert(`Download complete with ${failedImages.length} errors.`)
            }

            // Generate the zip file and trigger download
            const content = await zip.generateAsync({
                type: 'blob',
                compression: 'DEFLATE', // Use compression for smaller file size
                compressionOptions: { level: 6 }, // Medium compression level
            })

            saveAs(
                content,
                `images_${new Date().toISOString().slice(0, 10)}.zip`
            )
        } catch (error) {
            console.error('Error creating zip file:', error)
            alert('Failed to create zip file. Please try again.')
        } finally {
            // Reset downloading state regardless of outcome
            setIsDownloading(false)
            setDownloadProgress(0)
            setTotalImages(0)
        }
    }, [thumnailImages])

    const isEdit = get(props.location, 'state.isEdit', false)

    const downloadPercentage =
        totalImages > 0 ? Math.round((downloadProgress / totalImages) * 100) : 0

    const buttonSx = isDownloading
        ? {
              fontWeight: 200,
              bgcolor: '#555555', // Dark grey background
              color: 'white', // White text
              '&:hover': {
                  bgcolor: '#666666', // Slightly lighter on hover
              },
          }
        : { fontWeight: 200 }

    return (
        <>
            <div style={{ position: 'relative' }}>
                {getUserData().isAdmin && (
                    <Tooltip
                        title={
                            isDownloading
                                ? `Downloading: ${downloadPercentage}%`
                                : 'Download All Images'
                        }
                    >
                        <span>
                            <Button
                                className={classes.downloadButton}
                                onClick={downloadAllImages}
                                startIcon={
                                    isDownloading ? (
                                        <CircularProgress
                                            size={16}
                                            color="inherit"
                                        />
                                    ) : (
                                        <DownloadForOfflineIcon />
                                    )
                                }
                                variant="contained"
                                size="small"
                                sx={buttonSx}
                                disabled={isDownloading}
                            >
                                {isDownloading
                                    ? `Downloading (${downloadPercentage}%)`
                                    : 'Download All Images'}
                            </Button>
                        </span>
                    </Tooltip>
                )}

                {/* Progress indicator for download */}
                {isDownloading && (
                    <Box sx={buttonSx}>
                        <LinearProgress
                            variant="determinate"
                            value={downloadPercentage}
                            color="primary"
                        />
                        <Typography
                            variant="caption"
                            display="block"
                            textAlign="center"
                            mt={0.5}
                        >
                            Downloading {downloadProgress} of {totalImages}{' '}
                            images
                        </Typography>
                    </Box>
                )}

                <ImageList
                    id="thumbnailListId"
                    className={classes.horizontalThumbs}
                    cols={5}
                    rowHeight={THUMBNAIL_SIZE}
                >
                    {thumnailImages.concat(currentVideos).map((item, index) => {
                        const isVideo = Boolean(item?.video_id || item?.url)
                        const thumbnail = isVideo
                            ? get(item, 'url', PLACEHOLDER_IMAGE)
                            : extractImageUrlFromVariants(item, 'thumbnail') ||
                              PLACEHOLDER_IMAGE

                        // Determine variant type for resolution indicator
                        const variantType = (() => {
                            if (isVideo) return null
                            const variants = Array.isArray(item.variants)
                                ? item.variants
                                : []
                            if (variants.length === 0) return null
                            const hiRes = variants.find(
                                (v) => v.type === 'hi-res'
                            )
                            const lowRes = variants.find(
                                (v) => v.type === 'low-res'
                            )
                            if (hiRes) return 'hi-res'
                            if (lowRes) return 'low-res'
                            return null
                        })()

                        const imageViewKey =
                            IMAGE_VIEW_KEYS[item.image_view] ||
                            IMAGE_VIEW_KEYS[
                                IMAGE_VIEW_CONVERT[item.image_view]
                            ] ||
                            item.image_view

                        return (
                            <ImageListItem
                                key={index}
                                className={classNames({
                                    'selected-thumbnail':
                                        selectedThumbnailIndex === index,
                                    [classes.zoomThumb]: true,
                                })}
                                style={{ position: 'relative' }}
                                ref={(ref) =>
                                    (thumbnailRefs.current[index] = ref)
                                } // Assign ref to each thumbnail
                                onClick={() => {
                                    setSelectedThumbnailIndex(index) // Set selected index
                                    isVideo
                                        ? handleVideoThumbnailClick(item)
                                        : onSelect(item)
                                }}
                            >
                                {isVideo ? (
                                    <>
                                        <IconButton
                                            aria-label="delete video"
                                            className={classes.videoDeleteButton}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                e.stopPropagation()
                                                requestDeleteVideo(item)
                                            }}
                                        >
                                            <DeleteIcon fontSize="small" />
                                        </IconButton>
                                        <video
                                            controls
                                            width="200"
                                            height="150"
                                            poster={thumbnail}
                                        >
                                            <source
                                                src={thumbnail}
                                                type="video/mp4"
                                            />
                                            Your browser does not support the video
                                            tag.
                                        </video>
                                    </>
                                ) : (
                                    <>
                                        <img
                                            src={thumbnail}
                                            alt=""
                                            onError={(e) => {
                                                e.target.src = PLACEHOLDER_IMAGE
                                            }}
                                            onClick={onSelect(item)}
                                        />
                                        <ResolutionIndicator
                                            variantType={variantType}
                                        />
                                    </>
                                )}

                                <Typography
                                    id={
                                        isVideo
                                            ? IMAGE_VIEW_KEYS.VIDEO
                                            : IMAGE_VIEW_KEYS[
                                                  item.image_view
                                              ] ||
                                              IMAGE_VIEW_KEYS[
                                                  IMAGE_VIEW_CONVERT[
                                                      item.image_view
                                                  ]
                                              ] ||
                                              item.image_view ||
                                              'photoDetail.changeCategory.additional'
                                    }
                                    className={classes.imageType}
                                />

                                {isEdit ? (
                                    <ImageListItemBar
                                        classes={{ title: classes.titleText }}
                                        title={
                                            <Typography
                                                id={
                                                    isVideo
                                                        ? IMAGE_VIEW_KEYS.VIDEO
                                                        : IMAGE_VIEW_KEYS[
                                                              item.image_view
                                                          ] ||
                                                          IMAGE_VIEW_KEYS[
                                                              IMAGE_VIEW_CONVERT[
                                                                  item
                                                                      .image_view
                                                              ]
                                                          ] ||
                                                          item.image_view ||
                                                          'photoDetail.changeCategory.additional'
                                                }
                                            />
                                        }
                                        position="top"
                                        className={classes.titleBar}
                                    />
                                ) : (
                                    !item.__isPlaceholderImage &&
                                    imageViewKey !==
                                        'photoDetail.changeCategory.unknown' && (
                                        <ImageListItemBar
                                            position="top"
                                            actionPosition="left"
                                            className={classes.moreTitleBar}
                                            classes={{
                                                actionIcon:
                                                    classes.actionIconStyle,
                                                titleWrap: classes.titleWrap,
                                            }}
                                            actionIcon={
                                                isVideo ? null : (
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        justifyContent="space-between"
                                                    >
                                                        <CustomCheckboxSolid
                                                            key={
                                                                selected[index]
                                                                    ? `${index}-select`
                                                                    : `${index}-not-selected`
                                                            }
                                                            checked={
                                                                selected[index]
                                                            }
                                                            style={{
                                                                zIndex: 1002,
                                                            }}
                                                            onClick={handleSelect(
                                                                index
                                                            )}
                                                            icon={
                                                                <CheckboxBackground />
                                                            }
                                                        />
                                                        <PhotoMoreMenu
                                                            image={item}
                                                            onDeletePhoto={onDeletePhoto(
                                                                item
                                                            )}
                                                            onMovePhoto={onMovePhoto(
                                                                item
                                                            )}
                                                            onRefresh={
                                                                onRefresh
                                                            }
                                                            isFirst={
                                                                index === 0
                                                            }
                                                            isLast={
                                                                index >=
                                                                thumnailImages.length +
                                                                    currentVideos.length -
                                                                    1
                                                            }
                                                            onSortAllPhotos={
                                                                onSortAllPhotos
                                                            }
                                                            evalItem={evalItem}
                                                            index={index}
                                                        />
                                                    </Grid>
                                                )
                                            }
                                        />
                                    )
                                )}
                            </ImageListItem>
                        )
                    })}
                </ImageList>
            </div>
            <Modal open={isVideoModalOpen} onClose={handleVideoModalClose}>
                <div
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        maxWidth: '80vw',
                        maxHeight: '80vh',
                        width: 'auto',
                        height: '100%',
                        overflow: 'auto',
                    }}
                >
                    {selectedVideo && (
                        <video
                            controls
                            style={{ width: '100%', height: '100%' }}
                        >
                            <source src={selectedVideo.url} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    )}

                    {/* Close Button */}
                    <IconButton
                        aria-label="close"
                        style={{
                            position: 'fixed',
                            top: '8px',
                            right: '8px',
                            color: 'white',
                        }}
                        onClick={handleVideoModalClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
            </Modal>

            <Snackbar
                open={Boolean(videoToDelete)}
                onClose={handleCancelDeleteVideo}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    severity="warning"
                    variant="filled"
                    onClose={handleCancelDeleteVideo}
                    action={
                        <>
                            <Button
                                color="inherit"
                                size="small"
                                onClick={handleConfirmDeleteVideo}
                                disabled={isDeletingVideo}
                            >
                                Delete
                            </Button>
                            <Button
                                color="inherit"
                                size="small"
                                onClick={handleCancelDeleteVideo}
                                disabled={isDeletingVideo}
                            >
                                Cancel
                            </Button>
                        </>
                    }
                >
                    Delete this video?
                </Alert>
            </Snackbar>

            <Snackbar
                open={videoDeleteSuccessOpen}
                autoHideDuration={3000}
                onClose={() => setVideoDeleteSuccessOpen(false)}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    severity="success"
                    variant="filled"
                    onClose={() => setVideoDeleteSuccessOpen(false)}
                >
                    Video deleted
                </Alert>
            </Snackbar>

            <Snackbar
                open={Boolean(videoDeleteError)}
                autoHideDuration={5000}
                onClose={() => setVideoDeleteError('')}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert
                    severity="error"
                    variant="filled"
                    onClose={() => setVideoDeleteError('')}
                >
                    {videoDeleteError}
                </Alert>
            </Snackbar>
        </>
    )
}

ThumbnailList.propTypes = {
    classes: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    thumbColumns: PropTypes.number,
    images: PropTypes.array,
    selectedImage: PropTypes.object,
    onDeletePhoto: PropTypes.func,
    onRefresh: PropTypes.func,
    onSelect: PropTypes.func,
    onSelectThumbnail: PropTypes.func,
    onMovePhoto: PropTypes.func,
    selected: PropTypes.array,
    onSortAllPhotos: PropTypes.func,
    evalItem: PropTypes.object,
}

export default withRouter(withStyles(styles)(ThumbnailList))
